import { Theme } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

interface StyledAdminNavProps {
  isCustomTabs?: boolean;
}

export const Styled = styled.nav<StyledAdminNavProps>`
  background: var(--color-white-100);
  border-bottom: solid 1px var(--color-gray-100);
  display: flex;
  height: 50px;
  min-height: 50px;
  justify-content: ${(props) => (props.isCustomTabs ? "flex-start" : "center")};
  overflow: visible;
  position: relative;
  padding: 0 40px;
  z-index: 998;

  /* Allow nav to expand when dropdown is present */
  &:has(.submenu-dropdown) {
    height: 50px;
  }

  .wrapper {
    overflow: visible;
    padding: 10px 0 0;

    /* Ensure dropdown is not clipped */
    &:has(.submenu-dropdown) {
      height: auto;
      overflow: visible;
    }
  }

  .items {
    list-style: none;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;

    /* Ensure dropdown is not clipped when submenu is present */
    &:has(.submenu-dropdown) {
      overflow-y: visible;
    }

    &-item {
      display: inline-block;
      height: 40px;
      white-space: nowrap;

      &.submenu-dropdown {
        position: relative;
        z-index: 99998;

        /* Ensure dropdown content appears above everything */
        * {
          z-index: inherit;
          .menu.right {
            right: -90px;
          }
          .dropdown-item-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            width: 200px;
            gap: 16px;
          }
        }
      }
    }

    &-link {
      border-bottom: 4px solid transparent;
      color: var(--color-subtle);
      cursor: pointer;
      display: inline-flex;
      font-size: 0.75em;
      font-weight: 900;
      height: 40px;
      letter-spacing: 0.1em;
      line-height: 40px;
      margin-bottom: -1px;
      padding: 0 16px;
      text-transform: uppercase;
      transition: all 0.2s linear;
      align-items: center;
      justify-content: center;
      gap: 5px;
      i {
        background-color: var(--color-subtle);
        width: 20px;
        height: 20px;
      }
      &:hover,
      &.active {
        border-color: var(--color-primary-background);
        color: var(--color-foreground-active);
        i {
          background-color: var(--color-foreground-active);
        }
      }
    }
  }

  /* Dropdown specific styles */
  .admin-nav-submenu {
    z-index: 99999 !important;
    position: relative !important;

    > * {
      z-index: 99999 !important;
    }

    .dropdown-menu {
      z-index: 100000 !important;
      position: absolute !important;
      box-shadow:
        0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
      border: 1px solid var(--color-gray-100) !important;
      background: var(--color-white-100) !important;
      min-width: 200px;
      top: 100% !important;
      right: 0px !important;
      left: auto !important;
    }

    .dropdown-item {
      padding: 8px 12px !important;
      cursor: pointer !important;
      transition: background-color 0.15s ease-in-out !important;

      &:hover {
        background-color: var(--color-gray-50) !important;
      }

      &.active {
        background-color: var(--color-primary-background) !important;
        color: var(--color-white-100) !important;
      }
    }
  }

  @media screen and (max-width: ${Theme.break.small}) {
    padding: 0 20px;
  }
`;
